import React from 'react';

interface KpiCardProps {
  value: string | number;
  label: string;
  sub: string;
  accentColor?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({ value, label, sub, accentColor }) => (
  <div
    className="card h-100 p-4"
    style={{
      borderRadius: 'var(--bs-border-radius-lg)',
      borderTop: accentColor ? `3px solid ${accentColor}` : undefined,
    }}
  >
    <div
      style={{
        fontSize: '2.875rem',
        fontWeight: 700,
        lineHeight: 1,
        color: accentColor ?? 'inherit',
        letterSpacing: '-1px',
      }}
    >
      {value}
    </div>
    <div className="fw-bold mt-2" style={{ fontSize: 15 }}>
      {label}
    </div>
    <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>
      {sub}
    </div>
  </div>
);

export default KpiCard;
